import React from "react";
import { Link } from "react-router-dom";
import { Role, useAuth } from "@context/AuthContext";
import { cn } from "@lib/utils/tailwind";
import { MENU_ITEMS, BOTTOM_MENU_ITEMS } from "@lib/constants/general";

interface SidebarProps {
  open: boolean;
  handleDrawerToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ open, handleDrawerToggle }) => {
  const { role } = useAuth();

  return (
    <div
      className={cn(
        "transition-all duration-300 ease-in-out bg-gray-800 text-white fixed left-0 top-0 h-full overflow-hidden w-64 hidden lg:block"
      )}
    >
      <div className="flex items-center justify-between p-4">
        <img src={"/assets/Hublogiq_Logo_Wit_L.png"} alt="screenshot" />
      </div>

      <div className="divide-y flex flex-col">
        <div className="space-y-2 flex-1 p-2">
          {MENU_ITEMS.filter((item) => item.roles.includes(role as Role)).map(
            (item) => (
              <Link
                key={item.title}
                to={item.href}
                className={`flex items-center px-4 py-2 space-x-3 transition-all duration-200 hover:bg-gray-700 hover:rounded-md`}
              >
                <item.icon className="flex-shrink-0" />
                <span
                  className={cn(
                    `transform transition-all duration-300 opacity-100 scale-100`
                    // open ? "opacity-100 scale-100" : "opacity-0 scale-75"
                  )}
                >
                  {item.title}
                </span>
              </Link>
            )
          )}
        </div>

        <div className="absolute bottom-0 space-y-3 w-full">
          {BOTTOM_MENU_ITEMS.filter((item) =>
            item.roles.includes(role as Role)
          ).map((item) => (
            <Link
              key={item.title}
              to={item.href}
              className={`flex items-center px-4 py-2 space-x-3 transition-all duration-200 hover:bg-gray-700`}
            >
              <item.icon className="flex-shrink-0" />
              <span
                className={cn(
                  `transform transition-all duration-300 opacity-100 scale-100`
                  // open ? "opacity-100 scale-100" : "opacity-0 scale-75"
                )}
              >
                {item.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
